<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-circle-info"></i></div>
      <div>
        Informations utiles
        <div class="page-title-subheading">Informations diffusées aux familles</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle information
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Publier</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Annuler la publication</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table table-striped table-hover table-borderless table-sm" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Catégorie</th>
                                    <th>Titre</th>
                                    <th>Cible</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'periods' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.ci?.name}}</td>
                                    <td>{{d.title}}</td>
                                    <td>{{d.types}}</td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Publié</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Non publié</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une information utile</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Type<span class="text-danger ml-2">(*)</span></label>
                <ng-select name="ci_id" ngModel>
                    <ng-option *ngFor="let c of categories"  [value]="c.id">{{c.name}}</ng-option>
                </ng-select>
            </div>

            <div class=" form-group col-12 mb-3">
                <label for="">Cibles<span class="text-danger ml-2">(*)</span></label>
                <ng-select name="types" ngModel [multiple]="true">
                    <ng-option *ngFor="let c of cibles"  [value]="c">{{c}}</ng-option>
                </ng-select>
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Titre <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="title" class="form-control" ngModel>
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Contenu <span class="text-danger ml-2">(*)</span></label>
                <angular-editor name="content" [placeholder]="'Saisir le contenu'" ngModel required></angular-editor>
            </div>
           
            <div class="col-12 row">
                <div class=" form-group col-12 mb-3">
                    <label for="">Du <span class="text-danger ml-2">(*)</span></label>
                    <input type="date" name="publish_start_date" class="form-control" ngModel>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">AU <span class="text-danger ml-2">(*)</span></label>
                    <input type="date" name="publish_end_date" class="form-control" ngModel>
                </div>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une information utile</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Type<span class="text-danger ml-2">(*)</span></label>
                <ng-select name="ci_id" [(ngModel)]="selected_data.ci_id">
                    <ng-option *ngFor="let c of categories"  [value]="c.id">{{c.name}}</ng-option>
                </ng-select>
            </div>

            <div class=" form-group col-12 mb-3">
                <label for="">Cibles<span class="text-danger ml-2">(*)</span></label>
                <ng-select name="types" [(ngModel)]="selected_data.types" [multiple]="true">
                    <ng-option *ngFor="let c of cibles"  [value]="c">{{c}}</ng-option>
                </ng-select>
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Titre <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="title" class="form-control" [(ngModel)]="selected_data.title">
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Contenu <span class="text-danger ml-2">(*)</span></label>
                <angular-editor name="content" [placeholder]="'Saisir le contenu'" [(ngModel)]="selected_data.content" required></angular-editor>
            </div>
           
            <div class="col-12 row">
                <div class=" form-group col-12 mb-3">
                    <label for="">Du <span class="text-danger ml-2">(*)</span></label>
                    <input type="date" name="publish_start_date" class="form-control" [(ngModel)]="selected_data.publish_start_date">
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">AU <span class="text-danger ml-2">(*)</span></label>
                    <input type="date" name="publish_end_date" class="form-control" [(ngModel)]="selected_data.publish_end_date">
                </div>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="row">
            <div class="col-12 col-md-8">
                <dl class="mb-3">
                    <dt>Titre</dt>
                    <dd>{{selected_data.title}}</dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Contenu</dt>
                    <dd [innerHTML]="selected_data.content"></dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Type</dt>
                    <dd>{{selected_data.ci?.name}}</dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Cible</dt>
                    <dd>
                        <ul>
                            <li *ngFor="let c of selected_data.types">{{c}}</li>
                        </ul>
                    </dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Date début publication</dt>
                    <dd>{{selected_data.publish_start_date | date:"dd-MM-yyyy"}}</dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Date fin publication</dt>
                    <dd>{{selected_data.publish_end_date | date:"dd-MM-yyyy"}}</dd>
                   </dl>
            </div>
            <div class="col-12 col-md-4" style="overflow-y: scroll;">
                <h6><strong>Destinataire</strong></h6>
                <div class="bg-gray mb-1 rounded-0" *ngFor="let d of selected_data.destinators">
                   <p>{{d.name}}</p>
                </div>
            </div>
       

        </div>

      </div>
</ng-template>
